export default __webpack_public_path__ + "6e71f9984b657c85bbac34ebb2f87e25.png";